import './GenresPage.scss'
import { movieApi } from '../../redux/services/movieApi'
import { GenresList } from '../../components/GenresList/GenresList'
import { LoaderTopMovie } from '../../ui/LoaderTopMovie/LoaderTopMovie';
import { Link } from 'react-router-dom';

export interface GenreProps {
    genre: string;
}

export const GenresPage = () => {

    /* Получить жанры */
    const { data: getGenresMovie, isLoading, error, refetch } = movieApi.useGetGanreMovieQuery('/movie/genres')

    return (
        <section className='genres'>
            <div className='container'>
                <h2 className='title-min'>Жанры фильмов</h2>
                {isLoading && <LoaderTopMovie/>}
                {error &&
                    <div>
                        <h2 style={{ marginBottom: "10px" }}> Произошла ошибка</h2> <button className='btn btn-dark' onClick={() => refetch()}>Обновить список</button>
                    </div>}
                <ul className='genres__list'>
                    {getGenresMovie && getGenresMovie.map((genre, index) => (
                        <li key={index} className='genres__item'>
                            <Link to={`/genres/${genre}`}>
                            <GenresList genre={genre} />
                            </Link>
                            
                        </li>
                    ))}
                </ul>
            </div>
        </section>

    )
}
